export const avatarBgs = [
  "linear-gradient(179.79deg, #4981F2 -12.23%, rgba(73, 129, 242, 0.5) 99.85%)",
  "linear-gradient(180deg, #36CFC9 8.33%, rgba(54, 207, 201, 0.5) 104.17%)",
  "linear-gradient(180deg, #FFC53D 8.33%, rgba(255, 197, 61, 0.5) 104.17%)",
  "linear-gradient(180deg, #FF5319 -31.25%, rgba(255, 83, 25, 0.5) 104.17%)",
  "linear-gradient(180deg, #5856D6 -31.25%, rgba(88, 86, 214, 0.5) 104.17%)",
  "linear-gradient(180deg, #5AC8FA 0%, rgba(90, 200, 250, 0.5) 104.17%)",
  "linear-gradient(180deg, #34C759 0%, rgba(52, 199, 89, 0.5) 104.17%)",
];
